import { PRICE_LIST, MEMBER, MEMBER_MULTIPLIER } from "./enums/guaranteeTypes";

export const GUARANTEE_VALIDATION_RULES = {
  name: {
    isRequiredTrim: {
      value: true,
    },
  },
  category: {
    isRequiredTrim: {
      value: true,
    },
  },
  shortName: {},
  isQuebecHealthPremium: {
    mutuallyExclusiveWith: {
      value: {
        other: "isTaxableBenefitsProvincial",
        customMessageKey: "admin.guarantees.form.errors.quebecAndOutOfQuebec",
      },
    },
  },
  isTaxableBenefitsProvincial: {
    mutuallyExclusiveWith: {
      value: {
        other: "isQuebecHealthPremium",
        customMessageKey: "admin.guarantees.form.errors.quebecAndOutOfQuebec",
      },
    },
  },
  isDrivingMandatoryDependentGuarantee: {
    requiresGuaranteeType: {
      value: {
        type: PRICE_LIST.value,
      },
      customMessageKey: "admin.guarantees.form.errors.drivingRequiresPriceList",
    },
    incompatibleWithDependsOn: {
      value: true,
      customMessageKey: "admin.guarantees.form.errors.drivingCannotDependOn",
    },
  },
  isAutomaticallyChecked: {
    incompatibleWithMemberTypes: {
      value: {
        types: [MEMBER.value, MEMBER_MULTIPLIER.value],
      },
      customMessageKey: "admin.guarantees.form.errors.autoCheckIncompatibleWithMemberTypes",
    },
  },
  isMandatoryDependentGuarantee: {
    mutuallyExclusiveWith: {
      value: {
        other: "isMaster",
        customMessageKey: "admin.guarantees.form.errors.dependsOnCannotBeMaster",
      },
    },
  },
  dependsOnGuaranteeId: {
    incompatibleWithDriving: {
      value: true,
      customMessageKey: "admin.guarantees.form.errors.dependsOnCannotBeDriving",
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/guarantees/guaranteeValidationRules.js